<template>
    <a style="display:none;" class="header__cart header__bottom-btn" :href="order">
        <span class="header__cart-count" v-if="quantity && quantity > 0">{{ quantity }}</span>
        <svg class="icon"><use xlink:href="#cart"/></svg>
    </a>
</template>

<script>
export default {
    name: "CartCounter",
    props: ['order'],
    created() {
        this.$eventBus.$on('cart.increase', () => {
            this.updateCart();
        });
        this.$eventBus.$on('cart.decrease', () => {
            this.updateCart();
        });
    },
    methods: {
        updateCart() {
            this.$http.get('/api/cart/counter').then(res => {
                this.quantity = res.data;
            });
        }
    },
    mounted() {
        this.updateCart();
    },
    data() {
        return {
            quantity: 0,
        }
    },
}
</script>

<style scoped>

</style>
